import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { LifeCycle, TpaHandlerProviderSymbol, TpaPopupSymbol } from '@wix/thunderbolt-symbols'
import { TpaHandlersManagerSymbol } from 'feature-tpa-commons'
import { ComponentWillMountSymbol } from 'feature-components'
import { ModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import { UrlChangeHandlerForPage } from 'feature-router'
import {
	TpaModalSymbol,
	TpaEventsListenerManagerSymbol,
	TpaPopupApiSymbol,
	TpaSymbol,
	TpaComponentApiSymbol,
	SiteMapSymbol,
	TpaFullScreenModeSymbol,
	TpaLoadMeasureSymbol,
} from '../symbols'
import { handlers } from '../handlers'
import { TpaHandlersManager } from '../tpaHandlersManager'
import { TpaEventsListenerManager } from '../eventsListenerManager'
import { TpaPopupApiFactory } from '../tpaPopupApi'
import { TpaModal } from '../tpaModal'
import { TpaComponentApi } from '../tpaComponentApi'
import { TpaDs } from './tpa'
import { TpaComponentWillMount } from '../tpaComponentWillMount'
import { TpaSideEffects } from './tpaSideEffects'
import { TpaPopupDsFactory } from './tpaPopup'
import { DsSiteMap } from './siteMap'
import { TpaFullScreenMode } from '../tpaFullScreenMode'
import { PublicApiTPAHandler } from '../publicApiTPAHandler'
import { TpaComponentWillMountExtension } from './tpaComponentWillMountExtension'
import { SiteScrollDispatcher } from '../siteScrollDispatch'
import { TpaStateManager } from '../tpaStateManager'
import { TpaLoadMeasure } from '../tpaLoadMeasure'

export const editor: ContainerModuleLoader = (bind) => {
	bind(ModelUpdatesHandlersImplementor).to(TpaSideEffects)
	bind(SiteMapSymbol).to(DsSiteMap)
}

export const editorPage: ContainerModuleLoader = (bind) => {
	bind(TpaComponentApiSymbol).to(TpaComponentApi)
	bind(LifeCycle.PageDidMountHandler, TpaSymbol).to(TpaDs)
	bind(ComponentWillMountSymbol).to(TpaComponentWillMount)
	bind(ComponentWillMountSymbol).to(TpaComponentWillMountExtension) // TODO might be ok to just merge it with the public only TpaComponentWillMount
	bind(TpaHandlersManagerSymbol).to(TpaHandlersManager)
	bind(TpaHandlerProviderSymbol).to(PublicApiTPAHandler)
	bind(LifeCycle.PageDidMountHandler, TpaEventsListenerManagerSymbol).to(TpaEventsListenerManager)
	bind(TpaPopupApiSymbol, TpaPopupSymbol).to(TpaPopupApiFactory)
	bind(LifeCycle.PageDidMountHandler).to(TpaPopupDsFactory)
	handlers.forEach((factory) => {
		bind(TpaHandlerProviderSymbol).to(factory)
	})
	bind(LifeCycle.PageWillUnmountHandler, TpaModalSymbol).to(TpaModal)
	bind(TpaFullScreenModeSymbol).to(TpaFullScreenMode)
	bind(LifeCycle.PageWillMountHandler).to(SiteScrollDispatcher)
	bind(UrlChangeHandlerForPage).to(TpaStateManager)
	bind(TpaLoadMeasureSymbol).to(TpaLoadMeasure)
}
